export default "__VITE_ASSET__nT2fMlw6__"